<template>
	<div>
		<div  v-if="qColumns[0]">
			<div v-if="qColumns[0].title">
				<!--1st column header-->
				<v-layout>
					<v-flex :style="{'min-width': getTopColumnHeadingWidth() }" xs1>
						<p class="column-header" v-html="qColumnHeader" />
					</v-flex>
				</v-layout>
				<!--2nd column header-->
				<v-layout v-if="qColumns[0].title" />
				<v-layout v-else>
					<v-flex
						v-for="(titleSection, index) in qColumns"
						:key="index"
						:style="{ 'min-width': getColumnHeadingWidth() }"
						:xs="getColumnSize(index)">
						<p class="column-header">{{ titleSection.title }}</p>
					</v-flex>
				</v-layout>
				<!--3rd column header: When there are THREE 2nd column headers-->
				<v-layout v-if="qColumns.length === 3">
					<v-flex class="column-header" style="min-width: 150px; max-width: 150px;" xs2>
						<p>
							({{ qColumns[0].labels[0].id }})
							<br />
							{{ qColumns[0].labels[0].label }}
						</p>
					</v-flex>
					<v-flex class="column-header" style="min-width: 150px; max-width: 150px;" xs1>
						<p>
							({{ qColumns[0].labels[1].id }})
							<br />
							{{ qColumns[0].labels[1].label }}
						</p>
					</v-flex>
					<v-flex class="column-header right-divider" style="min-width: 150px; max-width: 150px;" xs1>
						<p>
							({{ qColumns[0].labels[2].id }})
							<br />
							{{ qColumns[0].labels[2].label }}
						</p>
					</v-flex>
					<v-flex v-for="(col, index) in qColumns[1].labels"
							:key="index" :class="addRightDivider(index + 1,
							qColumns[1].labels.length)"
							:xs="getColumnSize2(qColumns[1].labels.length)"
							style="min-width:150px;
							max-width:150px" >
								<p class="column-header"> ({{ col.id }})
									<br /> {{ col.label }}
								</p>
					</v-flex>
					<v-flex v-for="(col, index) in qColumns[2].labels"
							:key="index"
							:class="addRightDivider(index + 1, qColumns[2].labels.length)"
							:xs="getColumnSize2(qColumns[2].labels.length)"
							style="min-width:150px; max-width:150px" >
							<p class="column-header">
							({{ col.id }})
							<br /> {{ col.label }}
							</p>
					</v-flex>
				</v-layout>

				<!--3rd column header: When there are TWO 2nd column headers-->
				<v-layout v-if="qColumns.length === 2">
					<v-flex class="column-header" style="min-width: 160px; max-width: 160px;" xs2>
						<p>
							({{ qColumns[0].labels[0].id }})
							<br />
							{{ qColumns[0].labels[0].label }}
						</p>
					</v-flex>
					<v-flex class="column-header" style="min-width: 160px; max-width: 160px;" xs1>
						<p>
							({{ qColumns[0].labels[1].id }})
							<br />
							{{ qColumns[0].labels[1].label }}
						</p>
					</v-flex>
					<v-flex class="column-header right-divider" style="min-width: 160px; max-width: 160px;" xs1>
						<p>
							({{ qColumns[0].labels[2].id }})
							<br />
							{{ qColumns[0].labels[2].label }}
						</p>
					</v-flex>
					<v-flex
						v-for="(col, index) in qColumns[1].labels"
						:key="index"
						:class="addRightDivider(index + 1, qColumns[1].labels.length)"
						:xs="getColumnSize2(qColumns[1].labels.length)"
						style="min-width:150px; max-width:150px;">
						<p class="column-header">
							({{ col.id }})<br />
							{{ col.label }}
						</p>
					</v-flex>
				</v-layout>
			</div>

			<!--Column layout for sections with row labels/titles-->
			<div v-else>
					<v-layout v-if="qColumnHeader">
						<v-flex class="left-label" xs3 />
						<v-flex :style="{'min-width': getColumnHeadingWidth() }"
										:xs1="qColumns.length == 1 && qId != '4'"
										:xs2="qColumns.length == 2"
										:xs3="qColumns.length == 3"
										:xs4="qColumns.length == 4"
										:xs5="qColumns.length == 5"
										:xs6="qColumns.length == 6 || qId == '4'"
										:xs7="qColumns.length == 7">
							<p class="column-header" v-html="qColumnHeader" />
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex class="left-label" xs3 />
						<v-flex class="tb-width" v-for="col in qColumns" :key="col.colHeader" xs1>
							<p v-if="col.label" class="column-header">
								({{ col.id }})
								<br />
								{{ col.label }}
							</p>
						</v-flex>
					</v-layout>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AnswersColumns",
		props: {
			columns: Array,
			columnHeader: String,
			qId: String
		},
		data: () => ({
			qColumns: [],
			qColumnHeader: null
		}),
		watch: {
			columns: function (newVal, oldVal) {
				this.qColumns = newVal;
			},
			columnHeader: function (newVal, oldVal) {
				this.qColumnHeader = newVal;
			}
		},
		methods: {
			getColumnSize2 (labelCount) {
				switch (labelCount) {
					case 3: return 4; // 3 columns ? 4 grid units each
					case 4: return 3; // 4 columns ? 3 units each
					case 5: return 2; // 5 columns ? 2 units each
					case 6: return 2; // 6 columns ? 2 units each
					default: return 3; // fallback
				}
			},
			getColumnSize (index) {
				const labels = this.qColumns[index].labels.length;
				if (index === 0 || labels === 3) { return 3; }
				if (labels === 4) return 4;
				if (labels === 5) return 5;
				if (labels === 6) return 6;
				return 3;
				// fallback
		},
		getTotalNumColWidths () {
				const numCols = this.qColumns.reduce(
				(sum, col) => sum + col.labels.length, 0
			);
				return numCols + 1;
			},
			getTopColumnHeadingWidth () {
				var width = 200;
				width = width * this.getTotalNumColWidths().toString() + "px";
				return width;
			},
			getColumnHeadingWidth () {
				var width = 100;
				width = width * this.qColumns.length.toString() + "px";
				if (this.qId === '4') {
					width = '825px';
				}
				return width;
			},
			addRightDivider (pos, length) {
				return {
					'right-divider': pos === length
				}
			}
		}
	};
</script>

<style scoped>
	.column-header {
		text-align: center;
		font-weight: bold;
	}
	.left-label {
  min-width: 450px;
	}
	.left-label-other {
		min-width: 330px;
	}
	.tb-width {
		min-width: 150px;
	}
	.tb-width-other {
		min-width: 125px;
		border-right: 1px solid black;
	}
	.right-divider {
		border-right: 1px solid black;
	}
</style>
